import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import MainRoute from './Routes/MainRoutes';
import AppContextProvider from './context/AppContext';

function App() {
  return (
    <BrowserRouter>
      <AppContextProvider>
        <MainRoute />
      </AppContextProvider>

    </BrowserRouter>
  );
}

export default App;
